export default __webpack_public_path__ + "static/media/scande_mala.19b099fa.png";